module.exports = __webpack_public_path__ + "assets/img/detail-btn-16d1cb4f.png";